<template style="">
  <div class="abouindex">
    <div class="default-content">
      <!-- <div class="dc-top">
        <h3>中国科学院大学心理健康教育中心</h3>
        <p>
          中国科学院大学心理健康教育中心（简称“心理中心”）是为全校在读学生提供校园心理服务的专业机构。
        </p>
      </div> -->

      <div class="dc-bottom">
        <h3>心理中心的主要工作包括：</h3>
        <p>
          心理测评、心理咨询、心理讲座、心理主题学生活动和危机干预。
        </p>
        <p>
          目前，心理中心有近百类心理测量工具，为学生个人发展的多方面提供测评参考；每月组织讲座、读书会、成长小组、体验营等活动；每周在我校四个园区开展多种流派的日常心理咨询。
        </p>
        <p>
          心理中心的专家、老师和志愿者，愿意帮助和陪伴每一位同学，协助大家顺利完成自己的求学之路！
        </p>
      </div>
<!--      <el-button type="text" @click="centerDialogVisible = false">点击打开 Dialog</el-button>-->
      <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
          <span>{{this.Global.realName}}同学，您好！感谢您参加并完成国科大2023年学生普测，根据测试结果，建议您进行一对一的视频会谈。会谈中，将有专业人员与您进一步沟通，帮您更准确地了解自己的心理健康情况，并为您提出应对建议。<br></span>
          <span>此次访谈可预约时段将陆续放出，请及时关注访谈预约信息，及时预约。一次会谈约 15 分钟，请您预约视频会谈时间。</span>
          <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="centerDialog">预约</el-button>
          </span>
       </el-dialog>
    </div>
    <!-- <el-row :gutter="20">
        <el-col :span="16" >
          <div class="grid-content bg-purple" style="height: 190px;">
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple" style="height: 520px;">
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content bg-purple">
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
          </div>
          </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="4"><div class="grid-content bg-purple"></div></el-col>
        <el-col :span="16"><div class="grid-content bg-purple"></div></el-col>
        <el-col :span="4"><div class="grid-content bg-purple"></div></el-col>
      </el-row> -->

    <!-- <div ref="chart" style="width: 100%;height:400px;"></div> -->
    <img class="default-bg" src="../../assets/default-bg.png" alt="" />
    <img class="default-bg-tip" src="../../assets/default-bg-tip.png" alt="" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      centerDialogVisible: (this.Global.SourceNo!=''&&this.Global.haveInterview==0&&this.Global.openInterview==1)?true:false,
      // img:"../assets/cssxa.jpg"
    }
  },
  mounted() {
    // this.init()
  },
  methods: {
    centerDialog() {
      this.$router.push('/Measurement/InterviewAppointment')
    }
  },
}
</script>
<style>
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #fff;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.abouindex .default-bg {
  width: 100%;
  height: 100%;
  /* margin-top: -100px; */
}

.abouindex .default-bg-tip {
  position: absolute;
  z-index: 1001;
  width: 540px;
  height: 448px;
  right: 20px;
  top: 20px;
}
.abouindex {
  overflow: hidden;
  height: 100%;
  width: 100%;
  position: relative;
}

.abouindex .default-content {
  width: calc(100% - 620px);
  float: left;
  height: 100%;
  position: absolute;
  padding-left: 50px;
}

.dc-top {
  margin-top: 10%;
  height: 35%;
}

.dc-bottom {
  height: 40%;
}

.dc-top h3,
.dc-bottom h3 {
  font-size: 22px;
  color: rgba(39, 82, 156, 1);
  line-height: 52px;
}
.dc-top p,
.dc-bottom p {
  font-size: 18px;
  color: rgba(39, 82, 156, 1);
  line-height: 45px;
}
</style>
